export default __webpack_public_path__ + "static/media/logo.a419bfb3.svg";